import mdAxios from 'core/common/config/axios-config';
import {observable} from "mobx";
import {MovingBlocks} from "core/grid/gridUtils";
import {CERTFORMAT, MdCertificate, MdCertificateBeanConfig} from "administration/certificate/certificateDomain";
import {buildURL} from "core/common/utils/domUtils";


class CertificateService  {


  @observable public certificateListsMV: MovingBlocks;
  @observable public certificateObject: MdCertificate;
  @observable public certificateConfigs: MdCertificateBeanConfig[];


  // ////////// Certificate ////////////////////////////////////////////////////////////////////////////////


  deleteCertificate(certificateId: number): Promise<any> {
    return mdAxios.delete('/core/security/certificate/' + certificateId);
  }


  readCertificate(id): Promise<MdCertificate> {
    return mdAxios.get('/core/security/certificate/' + id)
      .then(response => new MdCertificate(response.data));
  }

  exportCertificateUrl(certFormat: CERTFORMAT, certificateId: number, password: string): string {
    return buildURL('/api/core/security/certificate/export/' + certFormat + '/' + certificateId, {password})
  }


  readCertificateBeanConfigs(): Promise<MdCertificateBeanConfig[]> {
    return mdAxios.get('/core/security/certificate-config')
      .then(response => response.data.map(json => new MdCertificateBeanConfig(json)) );
  }

  saveCertificateBeanConfigs(configs: MdCertificateBeanConfig[]): Promise<any> {
    return mdAxios.post('/core/security/certificate-config' , configs);
  }





}

const certificateService = new CertificateService();
export default certificateService;




// WEBPACK FOOTER //
// ./src/administration/certificate/certificateService.tsx